module.exports = __webpack_public_path__ + "img/white.3006d5c7.png";